module.exports = __webpack_public_path__ + "static/media/bulma.346e11a0.svg";